import { render, staticRenderFns } from "./ElementMinTableColumn.vue?vue&type=template&id=2e5f531c&scoped=true"
import script from "./ElementMinTableColumn.vue?vue&type=script&lang=js"
export * from "./ElementMinTableColumn.vue?vue&type=script&lang=js"
import style0 from "./ElementMinTableColumn.vue?vue&type=style&index=0&id=2e5f531c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e5f531c",
  null
  
)

export default component.exports